module.exports = __webpack_public_path__ + "img/108.865cb4ca.jpg";